// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1HDZs","label":"CategoryService_label__1TlHA","location":"CategoryService_location__3U5mS"};